import { render } from "./ConfigurationModuleAdminView.vue?vue&type=template&id=c92d7a0e"
import script from "./ConfigurationModuleAdminView.vue?vue&type=script&lang=js"
export * from "./ConfigurationModuleAdminView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__